import React, {
  HTMLAttributes,
  forwardRef,
  ComponentPropsWithRef,
} from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { ReactDefaultProps } from "../../types/react";

import styles from "./ProductImage.scss";

type IframeSlideBaseProps = {
  src: string;
  title: string;
  customClass?: string;
  aspectRatio?: number;
  active?: boolean;
};

export type IframeSlideProps = IframeSlideBaseProps &
  Omit<HTMLAttributes<HTMLIFrameElement>, "src">;

const propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  customClass: PropTypes.string,
  aspectRatio: PropTypes.number,
  active: PropTypes.bool,
} as const;

const defaultProps = {
  customClass: undefined,
  aspectRatio: 1,
  active: false,
} as const;

const validatedDefaultProps: ReactDefaultProps<
  IframeSlideBaseProps,
  typeof defaultProps
> = defaultProps;

const IframeSlideWithRef = (
  props: IframeSlideProps,
  forwardedRef: ComponentPropsWithRef<"iframe">["ref"]
): JSX.Element => {
  const { src, title, customClass, aspectRatio, active, ...restProps } = props;

  return (
    <div
      className={styles["iframe-wrapper"]}
      style={{ paddingTop: `${(aspectRatio || 1) * 100}%` }}
    >
      <iframe
        ref={forwardedRef}
        title={title}
        src={src}
        frameBorder="0"
        className={cx(styles.iframe, customClass)}
        {...restProps}
      />
    </div>
  );
};

export const IframeSlide = forwardRef(IframeSlideWithRef);

IframeSlide.displayName = "ProductImageIframeSlide";

IframeSlide.propTypes = propTypes;
IframeSlide.defaultProps = validatedDefaultProps;

export default IframeSlide;
